import { ACCOUNT_REQUIRED_FIELDS } from "@/interfaces/user";
import { usePage } from "@inertiajs/react";
import { PrivateUser } from "@/interfaces/user";
import { humanize } from "@/utils/humanize";

export default function MissingAccountFields() {
  const { props } = usePage();
  const missingFields = ACCOUNT_REQUIRED_FIELDS.filter(
    (f) => !props.user[f as keyof PrivateUser],
  );

  if (missingFields.length === 0) return null;

  return (
    <div className="border-line bg-azalea text-ink shadow-card flex flex-col gap-2 border-2 p-4">
      <p className="font-display text-subheading font-bold">
        Your profile is missing some information
      </p>

      <ul className="text-body ml-5 list-disc">
        {missingFields.map((f) => (
          <li key={f}>{humanize(f)}</li>
        ))}
      </ul>

      <p className="text-body">
        Save it in your Hack Club Account, then{" "}
        <a href="/auth/hca" className="text-link underline">
          reauthenticate
        </a>{" "}
        to fix it.
      </p>
    </div>
  );
}
